import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

type LivenessMoveState = {
  livenessMoveSteps: number;
  livenessMoveTimeout: number;
  livenessMoveFailedAttempts: number;
};

const { persistAtom } = recoilPersist();
export const activeLivenessState = atom<boolean>({
  key: 'activeLivenessState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export const livenessMoveState = atom<LivenessMoveState>({
  key: 'livenessMoveState',
  default: {
    livenessMoveSteps: 3,
    livenessMoveTimeout: 10,
    livenessMoveFailedAttempts: 3,
  },
  effects_UNSTABLE: [persistAtom],
});
